<template>
  <div class="cpm-wrapper" v-show="showPreview">
    <div class="cpm-body">
      <div class="img-wrapper">
        <img class="demo-img" :src="imgSrc" alt="" />
        <img class="close-icon" @click="onCloseImg" :src="require('@/assets/img/circle-black-close-icon.png')" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPreview: false,
      imgSrc: ''
    };
  },
  mounted() {},
  methods: {
    show(func) {
      this.showPreview = true;
      this.imgSrc = this.url;
      typeof func === 'function' && func.call(this, this);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    onCloseImg() {
      this.resolve('hide');
      this.hide();
    },
    hide() {
      this.showPreview = false;
      document.body.removeChild(this.$el);
      this.$destroy();
    }
  }
};
</script>

<style lang="scss" scoped>
.cpm-wrapper {
  .cpm-body {
    .img-wrapper {
      z-index: 999999999 !important;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      background: rgba($color: #000000, $alpha: 0.2);
      .demo-img {
        max-height: 671px;
        max-width: 1140px;
      }
      .close-icon {
        cursor: pointer;
        width: 32px;
        height: 32px;
        margin-top: 24px;
      }
    }
  }
}
</style>
